"use client";

import { c as _c } from "react/compiler-runtime";
import { useTheme } from "next-themes";
import Image from "next/image";
import { useEffect, useState } from "react";
interface CountdownProps {
  targetDate: Date;
}
export const Countdown = t0 => {
  const $ = _c(46);
  const {
    targetDate
  } = t0;
  const {
    resolvedTheme
  } = useTheme();
  const [mounted, setMounted] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [timeLeft, setTimeLeft] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== targetDate) {
    t2 = () => {
      setMounted(true);
      const calculateTimeLeft = () => {
        const now = new Date();
        const difference = targetDate.getTime() - now.getTime();
        if (difference > 0) {
          return {
            days: Math.floor(difference / 86400000),
            hours: Math.floor(difference / 3600000 % 24),
            minutes: Math.floor(difference / 1000 / 60 % 60),
            seconds: Math.floor(difference / 1000 % 60)
          };
        }
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      };
      setTimeLeft(calculateTimeLeft());
      const timer = setInterval(() => {
        const calculated = calculateTimeLeft();
        setTimeLeft(calculated);
        if (calculated.days === 0 && calculated.hours === 0 && calculated.minutes === 0 && calculated.seconds === 0) {}
      }, 1000);
      return () => clearInterval(timer);
    };
    t3 = [targetDate];
    $[1] = targetDate;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const basePath = mounted && resolvedTheme === "dark" ? "/drawables_night" : "/drawables";
  let t4;
  if ($[4] !== basePath) {
    t4 = (num, t5) => {
      const length = t5 === undefined ? 2 : t5;
      const str = num.toString().padStart(length, "0");
      return str.split("").map((digit, i) => <div key={i} className="relative w-6 h-8 sm:w-8 sm:h-10"><Image src={`${basePath}/icon_counter_digit${digit}.png`} alt={digit} fill={true} className="object-contain" unoptimized={true} /></div>);
    };
    $[4] = basePath;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const renderDigits = t4;
  const Colon = _temp;
  if (!mounted) {
    return null;
  }
  let t5;
  if ($[6] !== renderDigits || $[7] !== timeLeft.days) {
    t5 = renderDigits(timeLeft.days);
    $[6] = renderDigits;
    $[7] = timeLeft.days;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <div className="flex gap-0.5">{t5}</div>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-[10px] text-[#8E9285] uppercase tracking-wider mt-2 font-geist">Days</span>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <div className="flex flex-col items-center mx-1">{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Colon />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== renderDigits || $[16] !== timeLeft.hours) {
    t10 = renderDigits(timeLeft.hours);
    $[15] = renderDigits;
    $[16] = timeLeft.hours;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <div className="flex gap-0.5">{t10}</div>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="text-[10px] text-[#8E9285] uppercase tracking-wider mt-2 font-geist">Hours</span>;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11) {
    t13 = <div className="flex flex-col items-center mx-1">{t11}{t12}</div>;
    $[21] = t11;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Colon />;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== renderDigits || $[25] !== timeLeft.minutes) {
    t15 = renderDigits(timeLeft.minutes);
    $[24] = renderDigits;
    $[25] = timeLeft.minutes;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15) {
    t16 = <div className="flex gap-0.5">{t15}</div>;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="text-[10px] text-[#8E9285] uppercase tracking-wider mt-2 font-geist">Mins</span>;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t16) {
    t18 = <div className="flex flex-col items-center mx-1">{t16}{t17}</div>;
    $[30] = t16;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Colon />;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== renderDigits || $[34] !== timeLeft.seconds) {
    t20 = renderDigits(timeLeft.seconds);
    $[33] = renderDigits;
    $[34] = timeLeft.seconds;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t20) {
    t21 = <div className="flex gap-0.5">{t20}</div>;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <span className="text-[10px] text-[#8E9285] uppercase tracking-wider mt-2 font-geist">Secs</span>;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t21) {
    t23 = <div className="flex flex-col items-center mx-1">{t21}{t22}</div>;
    $[39] = t21;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t13 || $[42] !== t18 || $[43] !== t23 || $[44] !== t8) {
    t24 = <div className="flex flex-col items-center animate-in fade-in duration-500"><div className="flex items-start justify-center flex-wrap gap-y-2">{t8}{t9}{t13}{t14}{t18}{t19}{t23}</div></div>;
    $[41] = t13;
    $[42] = t18;
    $[43] = t23;
    $[44] = t8;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  return t24;
};
function _temp() {
  return <div className="text-[#B0D18B] text-2xl font-bold mx-0.5 sm:mx-1 self-start mt-1">:</div>;
}